// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"86":"d60b71c758041d71","373":"676996f8778b85d9"}[chunkId] + ".js";
};